import { useTranslation } from "react-i18next";

const OPTIONS = [
  { code: "es", flag: "🇻🇪", label: "ES" },
  { code: "en", flag: "🇬🇧", label: "EN" },
];

// Compact ES/EN flag toggle for the header.
export function LanguageToggle() {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "es";

  return (
    <div className="flex items-center rounded-full border border-neutral-200 overflow-hidden" data-testid="language-toggle">
      {OPTIONS.map((o) => {
        const active = current === o.code;
        return (
          <button
            key={o.code}
            type="button"
            onClick={() => i18n.changeLanguage(o.code)}
            data-testid={`lang-${o.code}`}
            aria-pressed={active}
            className={`flex items-center gap-1 px-2 py-1 text-xs font-semibold transition-colors ${
              active ? "bg-[#0066CC] text-white" : "bg-white text-neutral-500 hover:bg-neutral-50"
            }`}
          >
            <span className="text-sm leading-none">{o.flag}</span> {o.label}
          </button>
        );
      })}
    </div>
  );
}
